
import _ from 'lodash';

import { ContentCalcWorking } from './content-calc-working.js';


export class ContentCalcLoading extends ContentCalcWorking {
	constructor (options) {
		options = _.defaultsDeep(options || {}, {
			name: 'calc-loading',
			calcWorking: {
				message: 'готовим калькулятор',
			},
			visible: _.constant(true),
		});

		super(options);
	}
}